import React from "react";
import type { HeroProps } from "../types";
import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs";

const SimpleHero = ({
  title,
  titleOverride,
  subnavItems,
  path,
  hasBreadcrumbs = false,
  titleClassName = "",
}: HeroProps) => {
  return (
    <div>
      {hasBreadcrumbs && path && <Breadcrumbs variant="dark" path={path} />}
      <h1 className={titleClassName || "text-6xl"}>{titleOverride || title}</h1>
      {subnavItems && (
        <>
          <p className="text-lg font-bold">Table of Contents</p>
          <ul>
            {subnavItems.map((item) => (
              <li key={item.id}>
                <a href={`#${item.id}`}>{item.name}</a>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default SimpleHero;
